// 056A — Adolescente Mujer (curvas de crecimiento y Tanner; páginas 198-199 del PDF). Ver `bloques056abDatos.ts`.
import { crearFormularioAdolescente } from './FormularioAdolescente';

export const Formulario056A = crearFormularioAdolescente('056A', 'female');
